// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__CTprR","savePackageButton":"ClientWallet_savePackageButton__2bjux"};